export const Styles = [
    {
        name:"Awakenings",
        nav:"white",
        body:"black",
        navText:"black",
        bodyText:"#c4c4c4"
    },
    {
        name:"Legacies",
        nav:"red",
        body:"white",
        navText:"white",
        bodyText:"#640f18"
    },
    {
        name:"Convergence",
        nav:"#343740",
        body:"#ededed",
        navText:"white",
        bodyText:"#666a77"
    }
];